/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {

  async fetchTotalPartsOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/partsOrder/getTotalPartsOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_PARTS_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },


  async fetchPartsOrder({ commit }, payload) {
    
    
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/partsOrder/getPartsOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_PARTS_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewPartsOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/partsOrder/save`, payload.order)
      payload.order.idPartsOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_PARTS_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/pecas`).catch(() => { });
  },



  async removePartsOrder({ commit }, payload) {
    let idPartsOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/partsOrder/remove`, { idPartsOrder })
      payload.loading.close()
      commit('REMOVE_PARTS_ORDER', idPartsOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updatePartsOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/partsOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_PARTS_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/pecas`).catch(err => { });
  },

  async trashPartsOrder({ commit }, payload) {
    let idPartsOrder = payload.idOrder
    
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/partsOrder/trash`,{ idPartsOrder }
      )
      payload.loading.close()
      commit('REMOVE_PARTS_ORDER', idPartsOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  async fetchPartsOrderByPeriod({ commit }, payload) {
    try {
      payload.loading()
      const response = await axios.post(
        `${baseApiUrl}/partsOrder/getPartsOrderedByPeriod`,
        payload.data
      );
      payload.loading.close()
      commit('SET_PARTS_ORDER_FILTERED', response.data)
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/pecas").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },

  async trashFilteredPartsOrder({ commit }, payload) {
    let idPartsOrder = payload.idOrder
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/partsOrder/trash`,{ idPartsOrder }
      )
      payload.loading.close()
      commit('REMOVE_PARTS_ORDER_FILTERED', idPartsOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/pecas").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },
}
